import { useContext } from "react";
import { Badge, Button, Modal } from "react-bootstrap";
import { serverInfo } from "../../../../../../App";
// import SouvenirStatusImg from "../../../../../../../assets/images/starShowcase/shirt.png";
import noImage from "../../../../../../assets/images/backGroundBanner.png";
import "./StarShowcaseModal.css";

const StarShowcaseModal = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter "
      dialogClassName="my-modal-souvenir"
      centered
    >
      <Modal.Body className="modalShowcaseParent bg-dark card-bg">
        <div className="p-4">
          <div className="d-flex justify-content-between">
            <h2 className="headingStatus">Souvenir Status</h2>
            <div className="">
              <button className="close-button" onClick={props.onHide}>
                <i class="fa-sharp fa-solid fa-circle-xmark"></i>
              </button>
            </div>
          </div>

          <div className="underlineBlack"></div>

          <div className="row my-4">
            <div className="col-md-5">
              <img
                src={
                  props.souvenir?.image
                    ? imageCdnUrl + props.souvenir?.image
                    : noImage
                }
                alt=""
                className="img-fluid w-100"
              />
            </div>
            <div className="col-md-7">
              <div className="text-light">
                <h6>Name</h6>
                <p>{props.souvenir?.name}</p>
              </div>
              <div className="text-light">
                <h6>Mobile No</h6>
                <p>{props.souvenir?.mobile_no}</p>
              </div>
              <div className="text-light">
                <h6>Address</h6>
                <p>
                  {props.souvenir?.area}, {props.souvenir.city?.name},{" "}
                  {props.souvenir.state?.name}, {props.souvenir.country?.name}
                </p>
              </div>
              <div className="text-light">
                <h6>Price</h6>
                <p> {props.souvenir?.total_amount}$</p>
              </div>
              <div className="text-light">
                <h6>Short Description</h6>
                <p>{props.souvenir?.description}</p>
              </div>
              {props.souvenir?.status >= 2 ? (
                <div className="text-light">
                  <h6>Status</h6>
                  {props.souvenir?.status == 2 ? (
                    <Badge bg="secondary">Payment Complete</Badge>
                  ) : (
                    ""
                  )}
                  {props.souvenir?.status == 3 ? (
                    <Badge bg="secondary">
                      Processing to receive the product
                    </Badge>
                  ) : (
                    ""
                  )}
                  {props.souvenir?.status == 4 ? (
                    <Badge bg="secondary">Product Received from User</Badge>
                  ) : (
                    ""
                  )}
                  {props.souvenir?.status == 5 ? (
                    <Badge bg="secondary">
                      Processing to send the signature product
                    </Badge>
                  ) : (
                    ""
                  )}
                  {props.souvenir?.status == 6 ? (
                    <Badge bg="secondary">Out for Delivery</Badge>
                  ) : (
                    ""
                  )}
                  {props.souvenir?.status == 7 ? (
                    <Badge bg="secondary">Delivered</Badge>
                  ) : (
                    ""
                  )}

                  {/* <select name="data" id="data" className="form-control" style={{ background: " #bbc2d6", color: "black" }}>
                        <option value="">--Select--</option>
                        <option value="">Processing</option>
                        <option value=""></option>
                        <option value=""></option>
                        <option value=""></option>
                        <option value=""></option>
                      </select> */}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer> */}
    </Modal>
  );
};

export default StarShowcaseModal;
